<button (click)="onClick()" class="bubble">
  <wp-icon [flipX]="true" icon="message-lines" set="solid"></wp-icon>
</button>
